export default {
  antagonismTestsList: [],
};
